function CheckboxDisableInput() {
  $('input[type=checkbox][data-disable-input]').on('change', function (e) {
    const element = document.querySelector(e.target.dataset.disableInput);

    const isMany = e.target.dataset.isMany;
    const btnAttachNormal = $('.attach-normal');
    const btnAttachMany = $('.attach-many');

    const selectize = element.selectize;
    // Se o input for um selectize, a tratativa é diferente
    if (selectize) {
      validateIsMany(isMany, btnAttachNormal, btnAttachMany, selectize.isDisabled);
      if (selectize.isDisabled) {
        selectize.enable();
      } else {
        selectize.clear();
        selectize.disable();
      }
    } else {
      element.toggleAttribute('disabled');
    }
  });
}

function validateIsMany(isMany, btnAttachNormal, btnAttachMany, isDisabled) {
  if (btnAttachMany.length > 0 && btnAttachNormal.length > 0 && isMany) {
    if (isDisabled) {
      btnAttachNormal.css('display', 'block');
      btnAttachMany.css('display', 'none');
    } else {
      btnAttachNormal.css('display', 'none');
      btnAttachMany.css('display', 'block');
    }
  }
}

exports.init = CheckboxDisableInput;
